/**
 * This container is in charge of loading the user information and the list of products
 * available for her/him.
 */
class HomeContainer {
  /**
   * When the container gets activated, this will be filled with either the user name or his/her
   * email address (in case the `name` property is empty).
   * @type {String}
   */
  username = '';
  /**
   * When the container gets activated, this will be filled with the list of products available
   * for the user.
   * @type {Array}
   */
  productsList = [];
  /**
   * Whether or not there was an error retrieving the list of available products.
   * @type {Boolean}
   */
  hasError = false;
  /**
   * Whether or not the container is making the call to load the list of available products.
   * @type {Boolean}
   */
  loading = false;
  /**
   * @param {AppErrorHandler} appErrorHandler To handle the error in case the list of available
   *                                          products can't be retrieved.
   * @param {AppSession}      appSession      To get the user name and email address.
   * @param {Products}        products        To get the list of available products.
   */
  constructor(appErrorHandler, appSession, products) {
    'inject';

    /**
     * A local reference for the `appErrorHandler` service.
     * @type {AppErrorHandler}
     */
    this._appErrorHandler = appErrorHandler;
    /**
     * A local reference for the `appSession` service.
     * @type {AppSession}
     */
    this._appSession = appSession;
    /**
     * A local reference for the `products` service.
     * @type {Products}
     */
    this._products = products;
  }
  /**
   * When the container gets activated, load the user information and the list of available
   * products.
   */
  activate() {
    this._loadUserInfo();
    this._loadProducts();
  }
  /**
   * Loads the list of available products and saves it on the container.
   * @access protected
   * @ignore
   */
  _loadProducts() {
    this.loading = true;
    this._products.getProductsList()
    .then((list) => {
      this.productsList = list;
    })
    .catch((error) => {
      this._appErrorHandler.handle(error, 'There was an error loading the products');
      this.hasError = true;
    })
    .then(() => {
      this.loading = false;
    });
  }
  /**
   * Gets the user information for the session and saves the user name or email address for
   * the view.
   * @access protected
   * @ignore
   */
  _loadUserInfo() {
    const session = this._appSession.getSession();
    let username = session.user.name.replace(/"/g, '').trim();
    if (!username) {
      username = session.user.email;
    }

    this.username = username;
  }
}

export { HomeContainer };
